export enum DataLayerEventEnums {
  PAGEVIEW = 'pageview',
}

export type RouterDataLayerTypes = {
  url: string;
};
